import { render, staticRenderFns } from "./TabClassdetail.vue?vue&type=template&id=63aa79f6&scoped=true"
import script from "../../../services/teacher/DetailClassTab/tab-classdetail.js?vue&type=script&lang=js&external"
export * from "../../../services/teacher/DetailClassTab/tab-classdetail.js?vue&type=script&lang=js&external"
import style0 from "../../../assets/css/teacher/DetailClassTab/tab-classdetail.css?vue&type=style&index=0&id=63aa79f6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa79f6",
  null
  
)

export default component.exports